export const OPEN_BANKING_MODAL = 'page/OPEN_BANKING_MODAL';
export const OPEN_BANKING_MODAL_DATA = 'page/OPEN_BANKING_MODAL_DATA';
export const CLOSE_BANKING_MODAL = 'page/CLOSE_BANKING_MODAL';
